import Vue from "vue";

import App from "@/App.vue";
import router from "@/router/routes";
import store from "@/state/store/index.js";
import native from "@/native";
import "@/state/helpers/index.js";

// -----------------------------------------------------------------------------
// ORDEM DE CSS — não reordene sem ler isto.
//
// O CSS de terceiros vem PRIMEIRO e o do app por último. Antes era o inverso:
// "@/design/index.scss" estava aqui em cima e os temas do PrimeVue, do
// vue-toast-notification e do vue-select eram importados lá embaixo, junto com
// os respectivos plugins. Como o webpack extrai o CSS na ordem de importação,
// o tema de terceiro ganhava de qualquer regra nossa de mesma especificidade —
// era por isso que o <Calendar> (usado em 25 views) continuava com o azul, o
// raio e o anel de foco do tema `bootstrap4-light-blue`, ignorando os tokens
// do app.
//
// Os plugins JS correspondentes continuam sendo registrados mais abaixo; só o
// CSS subiu.
// -----------------------------------------------------------------------------
import "vue-toast-notification/dist/theme-bootstrap.css";
import "vue-select/dist/vue-select.css";
import "primevue/resources/themes/bootstrap4-light-blue/theme.css";
import "primeicons/primeicons.css";

import "@/design/index.scss";
import axios from "axios";

// Tema claro/escuro salvo no aparelho: aplicado antes do $mount para a tela
// não piscar no tema claro (ver utils/preferencias-ui.js).
import { iniciarPreferenciasUi } from "@/utils/preferencias-ui";
iniciarPreferenciasUi();

Vue.use(require("vue-moment"));

import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

import VueTranslate from "vue-translate-plugin";
Vue.use(VueTranslate);

import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import VueMask from "v-mask";
Vue.use(VueMask);

import VueRouter from "vue-router";
Vue.use(VueRouter);

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);

import ToastPlugin from 'vue-toast-notification';
Vue.use(ToastPlugin, {
  position: 'top-right',
  duration: 5000,
  dismissible: true,
});

import VueSocialSharing from "vue-social-sharing";
Vue.use(VueSocialSharing);

import vSelect from 'vue-select';
Vue.component('v-select', vSelect)

import PrimeVue from "primevue/config";
import PrimeLocale from "@/state/locale/primevue.pt-br.json";
Vue.use(PrimeVue, {
  locale: PrimeLocale,
});

// 🔐 ESSENCIAL PARA COOKIE ENTRE SUBDOMÍNIOS (OAUTH INVISÍVEL)
axios.defaults.withCredentials = true;
axios.defaults.baseURL = "https://api.salesteams.com.br";


// Ignora elementos XFBML do Facebook SDK (ex: <fb:login-button>)
Vue.config.ignoredElements = [/^fb:/];

// -----------------------------------------------------------------------------
// PONTE NATIVA — por que o `$mount` espera.
//
// Dentro do aplicativo, o container pode precisar RESTAURAR a sessão
// (`token`/`user`) do armazenamento do sistema para o `localStorage`. Isso é
// assíncrono e tem de terminar ANTES de o router montar: o guard de rota lê
// `localStorage.getItem("token")` na primeira navegação e, se não encontrar,
// manda para "/login" — que chama `logout()` e apaga o que sobrou.
//
// `native.ready()` tem prazo próprio (4 s) e NUNCA rejeita. No navegador comum
// ele resolve na hora, com `isNative === false`, e nada muda.
// -----------------------------------------------------------------------------
native.ready().then(() => {
  // Vibração curta ao trocar de tela dentro do aplicativo. Um dos sinais
  // "app-like" que a Apple reconhece na revisão da regra 4.2 — e são 3 linhas.
  if (native.isNative) {
    router.afterEach(() => native.haptic("light"));
  }

  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
});
